// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__WwGG2","inputDescription":"styles_inputDescription__3dHz7"};